// farmapremium

import URLS from './urls'
import { colors as generalColors, frontendcommonGeneralCss } from './../farmapremium/frontendcommon.js'

export const colors = {
  ...generalColors,
  background: '#ffffff',
  sidebarBackground: '#fafafa',
  sidebarBorder: '#e5f1f1',
  sidebarFooterBorder: '#fafafa',
  navlinkColor: '#B1B1B1',
  navlinkHoverBackground: '#f8f8f8'
}

export const frontendcommonCss = `
:root {
  ${frontendcommonGeneralCss}
  --fc-background: ${colors.background};
  --fc-sidebar-background: ${colors.sidebarBackground};
  --fc-sidebar-border: ${colors.sidebarBorder};
  --fc-sidebar-footer-border: ${colors.sidebarFooterBorder};
  --fc-navlink-color: ${colors.navlinkColor};
  --fc-navlink-hover-backgound: ${colors.navlinkHoverBackground};
  --fp-layout-top-space: 0px;
}
`
export const logo = `${URLS.FRONTEND_ASSETS}/logos/base_logo_color.png`
export const logoSmall = `${URLS.FRONTEND_ASSETS}/logos/base_logo_color_mini.png`
export const logoColor = ''
export const logoColorSmall = ''
